export default __webpack_public_path__ + "static/media/section1-process-bg.97011d05.png";